import React from 'react';
import { createMuiTheme, ThemeProvider } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { orange } from '@material-ui/core/colors';

const theme = createMuiTheme({
    palette: {
        primary: orange,
        secondary: {main: "#f9f9f9"},
        text: {
            default: '#fff',
        }
    },
});

export default function StButton(props) {
    return (
        <ThemeProvider theme={theme}>
            <Button
                variant="contained"
                color={props.color === undefined ? "primary" : props.color}
                onClick={props.onClick}
                type={props.type}
                href={props.href}
                disabled={props.isDisabled}
                style={props.style}
            >
                {props.text}
                {props.children}
            </Button>
        </ThemeProvider>
    )
}